<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { SearchCombobox, type SearchComboboxOption } from '@/shared/ui/search-combobox';
  import { filterFieldsByName, formatFieldOptionLabel } from '../../lib/matrix-fields';
  import type { MatrixField } from '../../model/matrix-field.types';

  const SEARCH_PLACEHOLDER = 'Buscar pelo ID do campo';
  const EMPTY_MESSAGE = 'Nenhum campo encontrado.';

  const props = defineProps<{
    modelValue: string | null;
    options: MatrixField[];
    placeholder: string;
    isLoading: boolean;
    ariaLabelledby?: string;
    disabled?: boolean;
  }>();

  const emit = defineEmits<{
    'update:modelValue': [value: string | null];
  }>();

  const searchTerm = ref('');

  const comboboxOptions = computed<SearchComboboxOption[]>(() =>
    filterFieldsByName(props.options, searchTerm.value).map((field) => ({
      value: field.name,
      label: formatFieldOptionLabel(field),
    }))
  );

  function onUpdate(value: string): void {
    emit('update:modelValue', value === '' ? null : value);
  }
</script>

<template>
  <SearchCombobox
    :model-value="modelValue ?? ''"
    :options="comboboxOptions"
    :loading="isLoading"
    :placeholder="placeholder"
    :search-placeholder="SEARCH_PLACEHOLDER"
    :empty-message="EMPTY_MESSAGE"
    :aria-labelledby="ariaLabelledby"
    :disabled="disabled"
    trigger-icon="search"
    class="w-[28rem] max-w-full bg-white-01"
    @search="searchTerm = $event"
    @update:model-value="onUpdate"
  />
</template>
